import React from 'react';
import { connect } from 'react-redux';
import { transactionService } from '../../_services';

class BuyForm extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            amount : '' , 
            conversion : 0 ,
            disableSubmit : false 
        }
        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event){
        let rate = this.props.order.rate ; 

        if(rate== 0){ return false}

        //calculate conversion 
        let conversion = parseFloat(event.target.value) / rate;

        this.setState({
            amount : event.target.value , 
            conversion : isNaN(conversion) ? conversion.toFixed(8) : conversion
        })
    }

    handleSubmit(event){
        event.preventDefault(); 
        
        const { conversion } = this.state; 
        const { authentication  , order } = this.props;
        
        let formBody = {
            buyerId : authentication.user.id , 
            sellerId : order.memberId , 
            amount : conversion , 
            coin : order.coin , 
            currency : order.currency , 
            postTradeId : order.id  , 
            rate : order.rate
        }

        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberBuyOrder(formBody);
    }

    render(){
        const { order  } = this.props ; 
        const { conversion , amount } = this.state; 

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ; 

        return (
            <React.Fragment>
            <h4>buy</h4>
            <form className="default-form is-clearfix m-t-md  m-b-md" onSubmit={this.handleSubmit}>
                {
                    order && 
                    <React.Fragment>
                        
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Merchant</label>
                            </div>
                            <div className="field-body">{order.memberName}</div>
                        </div>
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Price/{order.coin}</label>
                            </div>
                            <div className="field-body">{order.currency} {order.rate} </div>
                        </div>
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Min / Size</label>
                            </div>
                            <div className="field-body">
                                {order.coin} {order.min} - {order.coin} {order.size}
                            </div>
                        </div>


                        <div className="border-bottom p-t-xs m-b-md"></div>
                    
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Quantity</label>
                            </div>
                            <div className="field-body">
                                <div className="control has-icons-left">
                                    <input className="input is-small" type="text" placeholder="Buy Quantity" value={amount} onChange={this.handleChange} 
                                        required
                                    />
                                    <span className="icon is-small is-left">
                                        {order.currency}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">{order.coin}</label>
                            </div>
                            
                            <div className="field-body">{conversion}</div>
                        </div>
                        
                        <div className="control m-t-xs is-pulled-right">
                            <input type="submit" disabled={disableSubmit} className="button button-submit" value="Buy"/>
                        </div>
                    </React.Fragment>
                }
            </form>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    const {  authentication } = state;
    return {
        authentication
    };
}

const connected = connect(mapStateToProps)(BuyForm);
export { connected as BuyForm }; 



// WEBPACK FOOTER //
// ./src/Views/ExchangePage/BuyForm.jsx